import React from 'react'
import PropTypes from 'prop-types'
import {Scrollbar} from 'react-scrollbars-custom'
import SearchResultError from './SearchResultError'
import SearchResultEntry from './SearchResultEntry'
import AzubiListHOC from '#components/HOC/AzubiListHOC'

export class SearchResult extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      matchingAzubis: [],
    }
  }

  componentDidMount() {
    this.searchAzubiList()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchParam !== this.props.searchParam) {
      this.searchAzubiList()
    }
  }

  searchAzubiList = () => {
    const {azubis} = this.props
    const matchingAzubis = azubis.filter(azubi => this.checkIfAzubiMatchesSearchParam(azubi))

    this.setState({matchingAzubis})
  }

  checkIfAzubiMatchesSearchParam = azubi => {
    const {searchParam} = this.props
    const searchString = `${azubi.firstname} ${azubi.lastname} ${azubi.markt} ${azubi.ausbildungsberufString}`
    const splitParams = searchParam.split(' ')
    return splitParams.every(param => searchString.toLowerCase().includes(param.toLowerCase()))
  }

  render() {
    const {matchingAzubis} = this.state

    return (
      <div className="searchResult">
        <Scrollbar
          translateContentSizesToHolder={true}
          style={{
            minHeight: 76,
            maxHeight: 376,
            width: 700,
          }}
          noScrollX={true}
          noDefaultStyles={false}>
          {matchingAzubis.length > 0 ? (
            matchingAzubis.map(azubi => (
              <SearchResultEntry
                azubi={azubi}
                key={azubi.id}
                onNavigationButtonClick={() => this.props.onNavigationButtonClick()}
              />
            ))
          ) : (
            <SearchResultError />
          )}
        </Scrollbar>
      </div>
    )
  }
}

SearchResult.propTypes = {
  azubis: PropTypes.array,
  searchParam: PropTypes.string.isRequired,
  onNavigationButtonClick: PropTypes.func,
}

export default AzubiListHOC(SearchResult)
